module.exports = __webpack_public_path__ + "static/media/change-flight-icon.5ad92787.svg";